import {FooterActionTypes} from './footer.types'

export const setFooterIsVisible = () => ({
  type: FooterActionTypes.SET_FOOTER_IS_VISIBLE,
})

export const setFooterNotVisible = () => ({
  type: FooterActionTypes.SET_FOOTER_NOT_VISIBLE,
})
